
    import { Options, Vue } from 'vue-class-component';

    @Options({
        props: {
            contentClass: String,
        },
    })
    export default class BasicPageContent extends Vue {
        get hasFilterSlot() {
            return !!this.$slots['filter'] || !!this.$slots['filter-tabs'];
        }
    }
